import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Interceptor to prevent caching of translation/i18n JSON files
 * This ensures that after deployments, users get the latest translations
 * without needing to manually clear their browser cache
 */
@Injectable()
export class TranslationCacheInterceptorService implements HttpInterceptor {

  /**
   * Intercept HTTP requests for translation files and add cache-busting headers
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Remove query parameters to check the path
    const pathOnly = req.url.split('?')[0];
    if (pathOnly.includes('/assets/') && pathOnly.includes('/i18n/') && pathOnly.endsWith('.json')) {
      const modifiedReq = req.clone({
        setHeaders: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      return next.handle(modifiedReq);
    }
    return next.handle(req);
  }
}
